import React from 'react'
import { FaBullhorn } from "react-icons/fa";
import { Link } from 'react-router-dom';
import Liveagents from '../pages/images/white-menu (1).png'
import Agenthistory from '../pages/images/white-menu (2).png'
import Livelist from '../pages/images/delivery-mis (1).png'
import agentContect from '../pages/images/tts (2).png'

const AgentsConfiguration = [
    {
        title: "Journey Campaigns",
        description: "All Journey campaign reports.",
        slug: "/Journeys/JourneyCampaignActivity",
        image: Liveagents
    },
    {
        title: "Campaign Activity",
        description: "Daily insights on campaign performance here.",
        slug: "/WAMessage/WACampaignActivity",
        image: Agenthistory
    },
    {
        title: "Delivery Statistics",
        description: "Analyze message delivery with detailed stats.",
        slug: "/WAMessage/DeliveryStatistics",
        image: Livelist
    },
    {
        title: "Flow Report",
        description: "Track and analyze WhatsApp flow executions and performance.",
        slug: "/WAMessage/WAFlowHistory",
        image: agentContect
    }

];

function Report() {


    return (
        <>
            <div className='w-[100%] pt-0 pr-6 pl-2' >
                <div className='flex flex-col justify-start items-center border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md ml-4 '>
                    <div className=' flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'>  Campaigns Report   </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {AgentsConfiguration.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
        w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
        h-[160px] cursor-pointer text-center 
        [transform-style:preserve-3d] transition-all duration-300 ease-in-out 
        shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
        hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
        flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                  <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>
                            </div>

                        ))
                        }

                    </div>
                    <div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Report 
